// extracted by mini-css-extract-plugin
module.exports = {"bookableResourceSettings":"BookableResourceSettings_bookableResourceSettings__2yqNW"};